export default __webpack_public_path__ + "static/media/Degod.4af803c6.png";